export default __webpack_public_path__ + "static/media/house-parking-spot.93fc90ad.png";